// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ScrollToController from "./scroll_to_controller.js"
application.register("scroll-to", ScrollToController)

import MobileMenuController from "./mobile_menu_controller.js"
application.register("mobile-menu", MobileMenuController)

import FancyboxController from "./fancybox_controller.js"
application.register("fancybox", FancyboxController)
